import { Fragment } from 'react'

import { ArrowDown, ArrowUp, EllipsisVertical, EyeOff, Pin, PinOff, SlidersHorizontal } from 'lucide-react'
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, Separator, cn } from 'twyne-new.ui'

const ITEM_CLASS = 'cursor-pointer twy-subtle-accent-hover'
const ACTIVE_ITEM_CLASS = 'twy-subtle-accent text-blue-500 dark:text-blue-300'

export default function ColumnHeaderMenu({ pinned = false, sortDirection = null, onSortAsc, onSortDesc, onTogglePin, onHide, onOpenAllColumns, className }) {
  const groups = [
    [
      onSortAsc && { key: 'asc', label: 'Sort ascending', icon: ArrowUp, onClick: onSortAsc, active: sortDirection === 'asc' },
      onSortDesc && { key: 'desc', label: 'Sort descending', icon: ArrowDown, onClick: onSortDesc, active: sortDirection === 'desc' },
    ],
    [
      onTogglePin && { key: 'pin', label: pinned ? 'Unpin to left' : 'Pin to left', icon: pinned ? PinOff : Pin, onClick: onTogglePin },
      onHide && { key: 'hide', label: 'Hide column', icon: EyeOff, onClick: onHide },
    ],
    [
      onOpenAllColumns && { key: 'all', label: 'All columns...', icon: SlidersHorizontal, onClick: onOpenAllColumns },
    ],
  ].map(group => group.filter(Boolean)).filter(group => group.length)

  if (!groups.length) {
    return null
  }

  const stop = event => event.stopPropagation()

  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        variant='ghost'
        size='sm'
        onClick={stop}
        onMouseDown={stop}
        className={cn(
          'h-6 w-4 p-0 mr-2 shrink-0 twy-text-base-neutral hover:twy-text-base-accent',
          'outline-none! ring-0! focus:outline-none! focus-visible:outline-none! focus-visible:ring-0! shadow-none!',
          'opacity-0 group-hover:opacity-100 data-[state=open]:opacity-100 flex items-center justify-center',
          className,
        )}
      >
        <EllipsisVertical size={14} />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align='end' className='min-w-52'>
      {groups.map((group, index) => <Fragment key={group[0].key}>
        {index > 0 && <Separator className='my-1' />}
        {group.map(({ key, label, icon, onClick, active }) => <DropdownMenuItem
          key={key}
          icon={icon}
          iconSize={16}
          className={cn(ITEM_CLASS, active && ACTIVE_ITEM_CLASS)}
          onClick={onClick}
        >
          {label}
        </DropdownMenuItem>)}
      </Fragment>)}
    </DropdownMenuContent>
  </DropdownMenu>
}

export function SortToggle({ direction, onClick, className }) {
  const Icon = direction === 'desc' ? ArrowDown : ArrowUp
  const stop = event => event.stopPropagation()

  return <Button
    variant='ghost'
    size='sm'
    onClick={event => {
      stop(event)
      onClick()
    }}
    onMouseDown={stop}
    className={cn(
      'h-6 w-4 p-0 shrink-0 hover:twy-text-base-accent',
      'outline-none! ring-0! focus:outline-none! focus-visible:outline-none! focus-visible:ring-0! shadow-none!',
      'flex items-center justify-center',
      direction ? 'twy-text-base-accent' : 'twy-text-base-neutral opacity-0 group-hover:opacity-100',
      className,
    )}
  >
    <Icon size={14} />
  </Button>
}
